import ContractEditor from './ContractEditor.vue';

export default ContractEditor;
